import { createSlice } from "@reduxjs/toolkit";

const clientsSlice = createSlice({
  name: "clients",
  initialState: {
    Clients: null,
  },
  reducers: {
    clientsSuccess: (state, action) => {
      state.isFetching = false;
      state.Clients = action.payload;
    },

    clearClients: (state) => {
      state.Clients = null;
    },
  },
});

export const { clientsSuccess, clearClients } = clientsSlice.actions;
export default clientsSlice.reducer;
